import { render } from "./TemplateContainer.vue?vue&type=template&id=5fa6f3d0&scoped=true"
import script from "./TemplateContainer.vue?vue&type=script&lang=js"
export * from "./TemplateContainer.vue?vue&type=script&lang=js"

import "./TemplateContainer.vue?vue&type=style&index=0&id=5fa6f3d0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa6f3d0"]])

export default __exports__